export const displayDashForNull = (value) => (value ? value : '-');
export const displayBlankForNull = (value) => (value ? value : '');
